// Ported verbatim from the mobile app (PrecisionReactNative src/common/assets/images/equipment/eqBoxingEquipmentSVG.tsx); generated — regenerate rather than edit.
import * as React from "react";

type Props = {
  fill: string;
  width?: number;
  height?: number;
};

function EqBoxingEquipmentSVG(props: Props) {
  const {fill, width = 24, height = 24} = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none">
      <g clip-path="url(#clip0_513_61460)">
        <path
          d="M20 21V23.25H7.25V21"
          stroke="#1F2224"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M22.25 5.25V13.5C22.25 14.6935 21.7759 15.8381 20.932 16.682C20.0881 17.5259 18.9435 18 17.75 18H7.25C6.05653 18 4.91193 17.5259 4.06802 16.682C3.22411 15.8381 2.75 14.6935 2.75 13.5V9.75C2.75 9.15326 2.98705 8.58097 3.40901 8.15901C3.83097 7.73705 4.40326 7.5 5 7.5H8C8.79565 7.5 9.55871 7.81607 10.1213 8.37868C10.6839 8.94129 11 9.70435 11 10.5C11 11.2956 10.6839 12.0587 10.1213 12.6213C9.55871 13.1839 8.79565 13.5 8 13.5H7.25"
          stroke="#1F2224"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M4.85002 7.5C4.45494 6.8161 4.24793 6.03981 4.25002 5.25C4.25002 4.05653 4.72412 2.91193 5.56804 2.06802C6.41195 1.22411 7.55654 0.75 8.75002 0.75H17.75C18.9435 0.75 20.0881 1.22411 20.932 2.06802C21.7759 2.91193 22.25 4.05653 22.25 5.25C22.25 6.44347 21.7759 7.58807 20.932 8.43198C20.0881 9.27589 18.9435 9.75 17.75 9.75H10.9048"
          stroke="#1F2224"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
    </svg>
  );
}

export default EqBoxingEquipmentSVG;
